import './index.css'
import { Sparkles } from 'lucide-react'
import { can } from '../../lib/features'
import type { PlanTier } from '../../types'

export type AIImportState = 'idle' | 'loading' | 'done' | 'error'

interface AIImportButtonProps {
  state: AIImportState
  planTier: PlanTier
  onClick: () => void
}

export default function AIImportButton({ state, planTier, onClick }: AIImportButtonProps) {
  if (!can('ai_scanner', planTier)) return null

  const label =
    state === 'loading' ? 'Analisando…' :
    state === 'done'    ? 'Dados extraídos' :
    state === 'error'   ? 'Tentar novamente' :
    'Importar com IA'

  return (
    <button
      type="button"
      className={'bc-ai-import-btn' + (state === 'error' ? ' is-error' : '') + (state === 'done' ? ' is-done' : '')}
      onClick={onClick}
      disabled={state === 'loading'}
      aria-label={label}
    >
      <Sparkles size={14} />
      <span>{label}</span>
    </button>
  )
}
